module.exports = __webpack_public_path__ + "media/src/images/top_covers/com_autumn_01-aeea6d0271458e59dafc91b6e7e8e79a.png";